import BaseService from '@/features/BaseService';

export default class ZohoReportService extends BaseService {

  constructor() {
    super('zoho-reports');
  }

}



// WEBPACK FOOTER //
// ./src/features/zoho-report/ZohoReportService.js